var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExamSetCompetitionAdd = function SvgExamSetCompetitionAdd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.09961 0.871094H8.79961V3.47109H2.09961V0.871094Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10009 0.871094L0.500094 2.07109C9.37581e-05 2.47109 -0.199906 3.27109 0.200094 3.87109L2.80009 7.97109L5.60009 6.27109L2.10009 0.871094Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90039 0.871094L10.5004 2.07109C11.0004 2.47109 11.2004 3.27109 10.8004 3.87109L8.10039 7.97109L5.40039 6.27109L8.90039 0.871094Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59961 4.77148C3.49961 4.87148 2.49961 5.37148 1.59961 6.07148L2.89961 8.07148L5.69961 6.37148L4.59961 4.77148Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40039 6.27148L8.20039 7.97148L9.50039 5.97148C8.50039 5.37148 7.50039 4.87148 6.40039 4.77148L5.40039 6.27148Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.2709C11 14.3709 8.5 16.8709 5.5 16.8709C2.5 16.8709 0 14.3709 0 11.2709C0 8.1709 2.5 5.6709 5.5 5.6709C8.5 5.6709 11 8.1709 11 11.2709Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60039 11.2713C9.60039 13.5713 7.70039 15.4713 5.50039 15.4713C3.30039 15.4713 1.40039 13.5713 1.40039 11.2713C1.40039 8.97129 3.30039 7.07129 5.50039 7.07129C7.70039 7.07129 9.60039 8.97129 9.60039 11.2713Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80016 10.2709L6.50016 10.0709L6.00016 8.9709C5.90016 8.7709 5.80016 8.6709 5.60016 8.6709C5.50016 8.6709 5.30016 8.7709 5.20016 8.8709L4.70016 10.0709L3.40016 10.2709C3.10016 10.2709 2.90016 10.7709 3.20016 10.9709L4.10016 11.8709L3.90016 13.1709C3.80016 13.4709 4.20016 13.7709 4.50016 13.5709L5.60016 12.9709L6.70016 13.5709C7.00016 13.7709 7.40016 13.4709 7.30016 13.1709L7.10016 11.8709L8.00016 10.9709C8.30016 10.7709 8.10016 10.3709 7.80016 10.2709Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 13.6707C15.9996 15.4707 14.4996 16.8707 12.7996 16.8707C11.0996 16.8707 9.59961 15.3707 9.59961 13.6707C9.59961 11.9707 11.0996 10.4707 12.7996 10.4707C14.4996 10.4707 15.9996 11.8707 15.9996 13.6707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3994 14.1707H10.9994C10.6994 14.1707 10.3994 13.8707 10.3994 13.5707C10.3994 13.2707 10.6994 12.9707 10.9994 12.9707H14.3994C14.6994 12.9707 14.9994 13.2707 14.9994 13.5707C14.9994 13.8707 14.6994 14.1707 14.3994 14.1707Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 15.2705V11.8705C12.1992 11.5705 12.4992 11.2705 12.7992 11.2705C13.0992 11.2705 13.3992 11.5705 13.3992 11.8705V15.2705C13.3992 15.5705 13.0992 15.8705 12.7992 15.8705C12.3992 15.7705 12.1992 15.5705 12.1992 15.2705Z",
    fill: "url(#paint9_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.42331,
    y1: -2.20591,
    x2: 5.54411,
    y2: 4.76049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1.99859,
    y1: -0.399006,
    x2: 4.05229,
    y2: 12.7688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9.41679,
    y1: -0.552106,
    x2: 6.75909,
    y2: 11.0855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 4.65811,
    y1: -0.353915,
    x2: 2.72521,
    y2: 11.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 8.35409,
    y1: 0.243284,
    x2: 6.42119,
    y2: 12.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 3.1134,
    y1: 6.8626,
    x2: 11.4087,
    y2: 22.1646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 5.93439,
    y1: 9.34589,
    x2: 3.84039,
    y2: 18.6076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 5.15846,
    y1: 6.8575,
    x2: 5.96386,
    y2: 13.7031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 9.92621,
    y1: 14.1181,
    x2: 15.3034,
    y2: 13.0819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 10.8277,
    y1: 10.9969,
    x2: 13.7262,
    y2: 14.8842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.871094)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExamSetCompetitionAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ExamSetCompetitionAdd.8001facd.svg";
export { ForwardRef as ReactComponent };